// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/job_sync_status_summary" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiJobSyncStatusSummary } from "./constants";
import type { CdiJobSyncStatusSummaryResult } from "./types";

export const getCdiJobSyncStatusSummary = reactQueryFetcherAdapter(
  integrationsDirectCdiJobSyncStatusSummary,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate?: string,
    endDate?: string,
    integrationId?: string
  ): Promise<CdiJobSyncStatusSummaryResult> => {
    return fetch(
      "/integrations/direct/cdi/job_sync_status_summary",
      "GET",
      { app_group_id: appGroupId, start_date: startDate, end_date: endDate, integration_id: integrationId },
      { signal }
    );
  }
);
